import React from "react";
import {
  Grid,
  Button
} from "@mui/material";
import {
 makeStyles
} from "@mui/styles";
import clsx from "clsx";
import {getImage} from "../../../../../utils/image";
import getNumberBitDepth from "../../../../../utils/numberFormat";
import getTrans from "../../../../../languages/getTrans";

const formatAmount = (amount) => {
  const formattedAmount = getNumberBitDepth(
    amount,
    amount % 1 === 0 ? 0 : 2,
    '.',
    ' '
  );
  return `$${formattedAmount}`;
};

const PayInfoSelect = ({ item, amount }) => {
  const classes = useStyles();

  const {minPay, commission} = React.useMemo(() => {
    if (item?.minValue !== undefined || item?.commissionPercentage !== undefined || item?.commissionValue !== undefined) {
      const minValue = Number.parseFloat(item.minValue || 0);
      const commissionPercentage = Number.parseFloat(item.commissionPercentage || 0);
      const commissionValue = Number.parseFloat(item.commissionValue || 0);

      const formattedMinPay = formatAmount(minValue);

      let formattedCommission = '';
      if (commissionPercentage > 0 && commissionValue > 0) {
        const formattedCommissionValue = formatAmount(commissionValue);
        formattedCommission = `${commissionPercentage}% + ${formattedCommissionValue}`;
      } else if (commissionPercentage > 0) {
        formattedCommission = `${commissionPercentage}%`;
      } else if (commissionValue > 0) {
        formattedCommission = formatAmount(commissionValue);
      } else {
        formattedCommission = '0%';
      }

      return {
        minPay: formattedMinPay,
        commission: formattedCommission
      };
    }

    return {
      minPay: '$3',
      commission: '0%'
    };
  }, [item]);

  return (
    <div className={classes.root}>
      {Boolean(item.hint) && (
        <div className={classes.hintMessage} dangerouslySetInnerHTML={{__html: item.hint}}/>
      )}
      <div className={classes.information}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <div className={classes.informationItem}>
              <div className={classes.informationItemName}>{getTrans('payInfoSelect.Minimum payment amount')}</div>
              <div className={classes.informationItemValue}>{minPay}</div>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.informationItem}>
              <div className={classes.informationItemName}>{getTrans('payInfoSelect.Commission')}</div>
              <div className={classes.informationItemValue}>{commission}</div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "12px"
  },

  button: {
    gap: "6px",
    minHeight: 52,
    width: "100%",
    display: "flex",
    minWidth: "initial",
    alignItems: "center",
    flexDirection: "column",
    border: "1px solid #FFFFFF1A",
    background: "#FFFFFF0D!important",

    "&.--selected": {
      borderColor: "#FB7800!important",
    }
  },
  buttonIcon: {
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "& img": {
      height: "100%",
      maxWidth: "100%",
      objectFit: "contain",
      objectPosition: "50% 50%",
    }
  },
  buttonName: {
    display: "flex",
    maxWidth: "100%",
    fontSize: 16,
    color: "white",
    fontWeight: "500",
    lineHeight: "20px",

    "& span": {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    }
  },

  information: {
    marginTop: "16px",
  },
  informationItem: {
    display: "flex",
    flexDirection: "column",
  },
  informationItemName: {
    fontSize: 14,
    color: "#BDBDBD",
    lineHeight: "20px",
  },
  informationItemValue: {
    marginTop: "4px",
    fontSize: 18,
    color: "white",
    lineHeight: "20px",
    fontWeight: "500",
  },

  hintMessage: {
    fontSize: 14,
    color: "#FFFFFF",
    lineHeight: "18px",
    textAlign: "center",
  },
}));

export default PayInfoSelect;
